import React from "react";

const DefaultOption = ({ text, value, disabled = true }) => {
  return (
    text && (
      <option defaultValue={value} disabled={disabled}>
        {text}
      </option>
    )
  );
};

const Select = ({
  label,
  items,
  itemText,
  itemValue,
  id,
  loading,
  disabled,
  defaultOption = { value: "", text: "", disabled: true },
}) => {
  return (
    <div className="input-wrapper">
      <label htmlFor={id || label}>{label}</label>
      <select
        name={id}
        id={id || label}
        className={`input-wrapper__input ${
          disabled ? "input-wrapper__input--disabled" : ""
        }`}
      >
        <DefaultOption
          text={defaultOption.text}
          value={defaultOption.value}
          disabled={defaultOption.disabled}
        />

        {items.map((item, index) => (
          <option
            key={index + item[itemValue]}
            value={item[itemValue] || item[itemText]}
          >
            {item[itemText]}
          </option>
        ))}
      </select>

      {loading && (
        <div className="input-wrapper__loader">
          <div className="input-wrapper__bar" />
        </div>
      )}
    </div>
  );
};

export default Select;
